import { GzPolicyUiSettingsGridItemFormWebComponent } from '../../../../../../common/policyPanel/uiSettings/gridTemplate/form';
import { html, TemplateResult } from 'lit';
import { translateFn } from '../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../ui/gzForm/validators/required.validator';
import { CustomizableValidator } from '../../../../../../../ui/gzForm/validators/customizable.validator';
import { MAX_ENTITY_LENGTH, validateEntityByType } from '../utils/validators';
import { customElement, query } from 'lit/decorators.js';
import { GzFormFieldWebComponent } from '../../../../../../../ui/gzForm/formField';
import { GzDropdownWebComponent } from '../../../../../../../ui/gzDropdown';
import { GzInputWebComponent } from '../../../../../../../ui/gzInput/component/GzInputWebComponent';
import { FormGroup } from '../../../../../../../ui/gzForm/formGroup/form-group';
import { WEB_COMPONENT_POLICY_PANEL_ENCRYPTION_EXCLUSION_ITEM } from '../../../../../../../webcomponents.constants';
import { getExclusionItemTypeFormOptions } from '../../../../utils/uiSettings/encryption/encryption.values';
import { EncryptionExclusionItemType } from '@nirvana/shared/dtos/types/policies/common';
import { MaxLengthValidator } from '../../../../../../../ui/gzForm/validators/max-length.validator';

@customElement(WEB_COMPONENT_POLICY_PANEL_ENCRYPTION_EXCLUSION_ITEM)
export class GzEncryptionExclusionItemFormWebComponent extends GzPolicyUiSettingsGridItemFormWebComponent {
  @query('#excludedItemType')
  excludedItemType: GzFormFieldWebComponent<GzDropdownWebComponent>;

  @query('#excludedItemEntity')
  excludedItemEntity: GzFormFieldWebComponent<GzInputWebComponent, string>;

  public setError(error: string) {
    this.excludedItemEntity.setError(error);
  }

  renderFormFields(): TemplateResult {
    return html`
      <div class="policy-grid-item-form--field excluded-item-type">
        <gz-form-field id="excludedItemType">
          <gz-dropdown
            @selectionChanged="${this.handleTypeFieldChange}"
            gz-form-input
            label="${translateFn('Type')}"
            options="${JSON.stringify(getExclusionItemTypeFormOptions())}"
          ></gz-dropdown>
        </gz-form-field>
      </div>

      <div class="policy-grid-item-form--field excluded-item-path w-full">
        <gz-form-field id="excludedItemEntity">
          <gz-input
            gz-form-input
            label="${translateFn('Excluded items')}"
            placeholder="${translateFn('Type here')}"
          ></gz-input>
        </gz-form-field>
      </div>
    `;
  }

  createFormGroup(): void {
    this.excludedItemType.Validators = [RequiredValidator('')];
    this.excludedItemEntity.Validators = [
      RequiredValidator(translateFn('Required field')),
      CustomizableValidator(value =>
        validateEntityByType(this.excludedItemType.value as EncryptionExclusionItemType, value)
      ),
      MaxLengthValidator(
        MAX_ENTITY_LENGTH,
        translateFn('Maximum length permitted is {maxLength} characters', { maxLength: MAX_ENTITY_LENGTH })
      ),
    ];

    this.formGroup = new FormGroup({
      type: this.excludedItemType,
      entity: this.excludedItemEntity,
    });
  }

  private handleTypeFieldChange() {
    this.excludedItemEntity.validate();
  }

  resetForm(resetType = true): void {
    if (resetType) {
      this.excludedItemType.value = '';
      this.excludedItemType.resetField();
    }

    this.excludedItemEntity.value = '';
    this.excludedItemType.resetField();
    this.excludedItemEntity.resetField();
  }

  reset() {
    this.resetForm();
  }

  resetOnAdd() {
    this.resetForm(false);
  }
}
